// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"80":"716a8374436a4cf2","195":"de38f4e1fa91e371","203":"d0af183f29b57f7d"}[chunkId] + ".css";
};